import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';

export default function ReportFormSkeleton() {
  return (
    <Box>
      <Skeleton variant="rounded" height={50} width="100%" sx={{ mb: 1 }} />

      <Box>
        <Skeleton variant="rounded" height={24} width={200} sx={{ mb: 1 }} />
        <Skeleton variant="rounded" height={35} width={650} sx={{ mb: 2 }} />
      </Box>

      <Box>
        <Skeleton
          variant="rounded"
          height={24}
          width={200}
          sx={{ mt: 4, mb: 1 }}
        />

        {/* Repeatable fields */}
        <Skeleton variant="rounded" height={35} width={650} sx={{ mb: 1 }} />
        <Skeleton variant="rounded" height={20} width={400} sx={{ mb: 3 }} />

        <Skeleton variant="rounded" height={35} width={650} sx={{ mb: 1 }} />
        <Skeleton variant="rounded" height={20} width={400} sx={{ mb: 4 }} />

        <Skeleton variant="rounded" height={35} width={650} sx={{ mb: 1 }} />
        <Skeleton variant="rounded" height={20} width={400} sx={{ mb: 4 }} />

        <Skeleton variant="rounded" height={56} width={600} sx={{ mb: 2 }} />
        <Skeleton variant="rounded" height={20} width={400} sx={{ mb: 4 }} />

        <Skeleton variant="rounded" height={56} width={600} sx={{ mb: 2 }} />
        <Skeleton variant="rounded" height={20} width={400} sx={{ mb: 4 }} />
      </Box>

      <Box>
        <Skeleton variant="rounded" height={24} width={200} />
        <Skeleton variant="rounded" height={40} width={300} sx={{ mb: 2 }} />
      </Box>
    </Box>
  );
}
